//@flow
import React from "react";

type HardwareRepairProps = {
  color?: string,
};

const HardwareRepair = (props: HardwareRepairProps) => {
  return (
    <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 566.93 566.93">
      <path
        className="cls-1"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M73.15,274.33h91.44V219.47H73.15Zm18.29-36.57h54.87V256H91.44Z"
      />
      <path
        className="cls-2"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M256,219.47h18.29v18.29H256Z"
      />
      <path
        className="cls-3"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M219.46,219.47h18.28v18.29H219.46Z"
      />
      <path
        className="cls-4"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M73.15,493.78h91.44V438.92H73.15Zm18.29-36.57h54.87V475.5H91.44Z"
      />
      <path
        className="cls-5"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M256,438.92h18.29v18.29H256Z"
      />
      <path
        className="cls-6"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M256,475.5h18.29v18.28H256Z"
      />
      <path
        className="cls-7"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M219.46,475.5h18.28v18.28H219.46Z"
      />
      <path
        className="cls-8"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M219.46,438.92h18.28v18.29H219.46Z"
      />
      <path
        className="cls-9"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M73.15,329.19H91.44v18.29H73.15Z"
      />
      <path
        className="cls-10"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M73.15,365.77H91.44v18.29H73.15Z"
      />
      <path
        className="cls-11"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M109.73,365.77H128v18.29H109.73Z"
      />
      <path
        className="cls-12"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M109.73,329.19H128v18.29H109.73Z"
      />
      <path
        className="cls-13"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M493.77,237.76a71.88,71.88,0,0,0-20.63,3L424.4,192l48.92-48.91c8.81-8.82,20.95-14.12,35.76-15.4,29.93-2.86,54.68-27.61,57.55-57.55a63.86,63.86,0,0,0-2.47-24.74l-4.43-14.6-41,41L501,65.94l-5.9-17.73,41-41L521.49,2.79A63.7,63.7,0,0,0,496.76.32c-29.94,2.86-54.68,27.61-57.62,58.21-1.2,14.14-6.51,26.29-15.33,35.1l-48.91,48.9L326,93.62a52.3,52.3,0,0,1-15.07-32.16l-.15-1.7c-2.57-28.26-23-52.17-49.55-58.14a63.74,63.74,0,0,0-32.91,1.15L213.7,7.19l41,41L248.8,65.92l-17.73,5.92-41-41-4.43,14.61a64,64,0,0,0-1.15,32.91c6,26.61,29.89,47,58.1,49.54l1.72.18a52.23,52.23,0,0,1,32.18,15.06l3.19,3.18h-234A45.77,45.77,0,0,0,0,192V521.21a45.77,45.77,0,0,0,45.72,45.72h256a45.77,45.77,0,0,0,45.72-45.72V269l27.43-27.43,48.73,48.73a72.29,72.29,0,0,0-3,20.64,73.15,73.15,0,1,0,73.15-73.15Zm-57-131.21c11.91-11.9,19.05-28,20.67-46.94,2-21.38,19.72-39.06,41.09-41.1l.46,0L474.17,43.26,486.56,80.4l37.13,12.38L548.48,68c0,.16,0,.31-.05.46-2,21.38-19.71,39.05-41.56,41.14-18.5,1.59-34.57,8.72-46.48,20.63L313.06,277.52c-11.9,11.91-19.05,28-20.67,47-2.05,21.38-19.72,39-41.09,41.1l-.46,0,24.79-24.79-12.38-37.15-37.14-12.38-24.79,24.8c0-.15,0-.3.05-.46,2-21.37,19.71-39.05,41.56-41.13,18.5-1.59,34.57-8.73,46.48-20.63ZM189.2,292.62H54.87V201.18H292.61v23.65L276.49,241c-8.82,8.81-21,14.12-35.77,15.4C218.29,258.49,198.78,272.92,189.2,292.62ZM310.89,177.54,325.4,192l-14.51,14.5Zm-18.28,5.35H54.87V164.61H292.61ZM54.87,420.63H292.61v91.44H54.87Zm237.74-18.28H54.87V310.91H183.74c-.15,1-.47,2-.57,3a63.83,63.83,0,0,0,2.47,24.73l4.43,14.6,41-41,17.73,5.91,5.91,17.72-41,41,14.61,4.43a63.8,63.8,0,0,0,18.58,2.77q3.06,0,6.15-.3a63.56,63.56,0,0,0,39.57-19.45ZM246,109.86l-1.72-.17c-20.46-1.85-37.71-16.39-42-35.34a46.78,46.78,0,0,1-1-6.37l24.79,24.8L263.27,80.4l12.38-37.14L250.86,18.47a48.54,48.54,0,0,1,6.38,1c18.95,4.25,33.48,21.51,35.34,42l.13,1.69a70.6,70.6,0,0,0,20.35,43.44L362,155.46l-23.64,23.65L289.41,130.2A70.48,70.48,0,0,0,246,109.86Zm83.16,411.35a27.47,27.47,0,0,1-27.43,27.44h-256a27.47,27.47,0,0,1-27.43-27.44V192a27.38,27.38,0,0,1,18.29-25.75V512.07a18.3,18.3,0,0,0,18.29,18.29H292.61a18.3,18.3,0,0,0,18.28-18.29V324.13c1.45-13.52,6.6-25.17,15.1-33.68l3.19-3.19ZM493.77,365.77a54.74,54.74,0,0,1-51.12-74.63l2.15-5.55-57-57L411.48,205l57,57,5.55-2.15a54.84,54.84,0,1,1,19.78,106Z"
      />
      <path
        className="cls-14"
        fill={props.color === "white" ? "#fff" : "#6d55ff"}
        d="M493.77,274.33a36.58,36.58,0,1,0,36.57,36.58A36.62,36.62,0,0,0,493.77,274.33Zm0,54.86a18.29,18.29,0,1,1,18.29-18.28A18.3,18.3,0,0,1,493.77,329.19Z"
      />
    </svg>
  );
};

export default HardwareRepair;
